import { cn, NoddiIcon } from 'noddi-ui-common';
import { formatLicensePlate } from 'noddi-util';
import { FleetSwapTranslations } from './fleetSwapTranslations';
import { FleetSwapCandidate, FleetSwapOutgoing } from './fleetSwapTypes';

type Props = {
  outgoing: FleetSwapOutgoing;
  incoming: FleetSwapCandidate;
  translations: FleetSwapTranslations;
};

export const FleetSwapReview = ({ outgoing, incoming, translations: t }: Props) => {
  const scheduleName = outgoing.fleetScheduleName;
  const effects = [
    t.outgoingLeaves(outgoing.licensePlateNumber, scheduleName),
    ...(incoming.isNewToFleet ? [t.addedToFleet(incoming.licensePlateNumber)] : []),
    t.incomingJoins(incoming.licensePlateNumber, scheduleName)
  ];

  return (
    <div className='flex flex-col gap-5'>
      <div className='grid grid-cols-[1fr_auto_1fr] items-stretch gap-2'>
        <CarCard label={t.removed} plate={outgoing.licensePlateNumber} carDisplayName={outgoing.carDisplayName} />
        <div className='flex items-center justify-center text-primary'>
          <NoddiIcon name='ArrowRight' size='medium' />
        </div>
        <CarCard
          label={t.added}
          plate={incoming.licensePlateNumber}
          carDisplayName={incoming.carDisplayName}
          highlighted
        />
      </div>

      <div className='flex flex-col gap-2'>
        <span className='text-xs font-semibold text-muted-foreground'>{t.whatHappens}</span>
        <ul className='flex flex-col gap-2'>
          {effects.map((effect) => (
            <li key={effect} className='flex items-start gap-2 text-sm'>
              <span className='mt-0.5 flex size-4 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary'>
                <NoddiIcon name='Check' size='xSmall' />
              </span>
              <span>{effect}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

type CarCardProps = { label: string; plate: string; carDisplayName: string | null; highlighted?: boolean };

const CarCard = ({ label, plate, carDisplayName, highlighted }: CarCardProps) => (
  <div
    className={cn(
      'flex flex-col gap-1 rounded-lg border p-4',
      highlighted ? 'border-primary bg-primary/5' : 'border-border'
    )}
  >
    <span className='text-xs font-semibold text-muted-foreground uppercase'>{label}</span>
    <span className='text-sm font-semibold tracking-wider tabular-nums'>{formatLicensePlate(plate)}</span>
    {carDisplayName && <span className='text-xs text-muted-foreground'>{carDisplayName}</span>}
  </div>
);
